module.exports = __webpack_public_path__ + "f0fe60399c34bab4d55e63b9e1b27f33.glb";